import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCheckbox2ListComponent } from './fi-checkbox2-list.component';
import { FiCheckbox2Component } from './fi-checkbox2.component';
import { FormsModule } from '@angular/forms';
import { FiCheckbox2AdapterService } from '@fi-shared/fi-checkbox2/fi-checkbox2-adapter.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
    imports: [CommonModule, FormsModule, MatCheckboxModule],
    declarations: [FiCheckbox2ListComponent, FiCheckbox2Component],
    exports: [FiCheckbox2ListComponent, FiCheckbox2Component],
    providers: [FiCheckbox2AdapterService],
})
export class FiCheckbox2Module {}
